import * as actionTypes from './actionTypes';

const initState = {
    user_id : ''
  }

const addUserReducer = function(state = initState, action){
    const response = action.response;
    switch(action.type){
        case actionTypes.ADD_IN_USER_SUCCESS:
            return { ...state,user_id:response.userid, response };
        case actionTypes.ADD_IN_USER_ERROR:
            return { ...state,user_id:0, response };
        default:
            return state;
    }
}
export default addUserReducer;